import { useTranslation } from "react-i18next";
import { Button } from "antd";

import AuthCard from "../../components/auth/AuthCard";
import { usePageTitle } from "../../utils/usePageTitle";

export const PasswordResetSuccessPage = () => {
  const { t } = useTranslation();
  usePageTitle(t("passwordRecovery.success.title"));

  return (
    <AuthCard>
      <h1>{t("passwordRecovery.success.title")}</h1>
      <p>{t("passwordRecovery.success.description")}</p>
      <Button
        type="primary"
        size="large"
        href="/login/1"
        style={{ marginTop: 8 }}
      >
        {t("signin.buttonText")}
      </Button>
    </AuthCard>
  );
};
